// extracted by mini-css-extract-plugin
module.exports = {"cell":"CollegeAdminCell_cell__3eB-Z"};